// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__4365z","error":"Notes_error__TaWhz","noYet":"Notes_noYet__DdBcR"};